<template>
  <section>
    <v-alert v-if="display_alert" :type="alert_type" dismissible>
      {{ alert_text }}
    </v-alert>

    <v-container>
      <v-row v-for="row in rows" :key="row.id">
        <v-col>
          <v-text-field
            v-model="row.source_image_url"
            label="Source Image URL"
          ></v-text-field>
        </v-col>
        <v-col>
          <v-select
            :items="methods"
            v-model="row.method"
            label="Method"
          ></v-select>
        </v-col>
        <v-col>
          <v-text-field
            v-model="row.text_list"
            label="Text List (comma separated)"
          ></v-text-field>
        </v-col>
        <v-col>
          <v-select
            :items="boolean_choices"
            v-model="row.resize"
            label="Resize?"
          ></v-select>
        </v-col>
        <v-col>
          <v-select
            :items="boolean_choices"
            v-model="row.remove_background"
            label="Remove Background?"
          ></v-select>
        </v-col>
        <v-col>
          <v-select
            :items="boolean_choices"
            v-model="row.add_watermarks"
            label="Watermarks?"
          ></v-select>
        </v-col>
        <v-col>
          <v-select
            :items="boolean_choices"
            v-model="row.add_cta"
            label="Add CTA?"
          ></v-select>
        </v-col>
      </v-row>
    </v-container>
    <v-btn color="primary" :loading="waiting_result" @click="batch_paint">Submit</v-btn>
    <h2>Result:</h2>
	<ul>
		<li v-for="url in urls" :key="url"><a :href="full_result_url(url)">Video Link</a></li>
	</ul>
  </section>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
export default {
  props: ["user", "subscription_plan", "api_prefix"],
  data() {
    return {
      waiting_result: false,
      num_rows: 5,
      rows: [],
      methods: ["pencil", "oil"],
      boolean_choices: [true, false],
      result: null,
	  urls: [],
      swap_error: false,
      result_url: null,
      display_alert: false,
      alert_type: "success",
    };
  },
  components: {},
  mounted: function () {
    var data = [];
    for (const x of Array(5).keys()) {
      data.push({
        id: x,
        source_image_url: null,
        method: "pencil",
        add_watermarks: false,
        remove_background: false,
        resize: true,
        add_cta: true
      });
    }
    console.log(data);
    this.rows = data;
  },
  computed: {
  },
  methods: {
    full_result_url(url) 
	{
      return "https://s3.us-west-2.amazonaws.com/" + url;
    },
	generate_form_name(prefix, key) {
      return prefix + key;
    },
    unique_id() {
      return uuidv4();
    },
    async batch_paint() {
      let self = this;

      self.waiting_result = true;

      /*const formData = new FormData(this.$refs["form"]); // reference to form element
      const data = {}; // need to convert it before using not with XMLHttpRequest
      for (let [key, val] of formData.entries()) {
        Object.assign(data, { [key]: val });
      }*/

      var response = await self.$http.post(self.api_prefix + "/batch_paint", {
        rows: self.rows,
      });
      if (response.data != null) 
	  { 
		self.waiting_result = false;
        for (const item of response.data) 
		{
          self.urls.push(item.file_location)
		}
      }
    },
  },
  created() {
    // `this` points to the vm instance
  },
};
</script>

<style scoped>
#waiting_result_spinner {
  margin: 0 auto;
  display: block;
}
</style>